import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialStateT = {
    servicePackages: Record<number, string>;
}

const initialState: InitialStateT = {
    servicePackages: {}
}

export const servicePackageSlice = createSlice({
    name: 'servicePackage',
    initialState,
    reducers: ({
        setInitialState: (state, action: PayloadAction<Record<number, string>>) => {
            state.servicePackages = action.payload;
        },
        setServicePackages: (state, action: PayloadAction<Record<number, string>>) => {
            state.servicePackages = action.payload;
        },
    }),
});

export const { setInitialState, setServicePackages } = servicePackageSlice.actions;

export default servicePackageSlice.reducer;